/**
 *
 * FlashCardLanding
 *
 */

import { FlashCardBookMixin } from '@/scripts/FlashCard/FlashCardLanding/mixins/FlashCardBookMixin';
import MainModeFlashCardItem from '@/views/MainMode/MainModeCourse/MainModeFlashCardLanding/components/MainModeFlashCardItem.vue';

export default {
  name: 'MainModeFlashCardBook',

  mixins: [FlashCardBookMixin],

  components: {
    MainModeFlashCardItem,
  },
};
